import { AI_VISIBILITY } from "@/constant/constantsThrougoutProject";

/**
 * Canonical app module token. Prefer this (or {@link isAiVisibilityModule})
 * over hard-coded `"aivisibility"` / `"ai_visibility"` in app logic.
 *
 * Route / ViewDefinition / featureStatus still spell the path segment
 * `"aivisibility"`; the metrics catalog uses `"ai_visibility"`. This helper
 * treats all three as the same module.
 */
export function isAiVisibilityModule(module?: string | null): boolean {
  if (!module) return false;
  const compact = module.toUpperCase().replace(/[-_]/g, "");
  return compact === AI_VISIBILITY.replace(/_/g, "");
}
